export const notificationsCentre = {
  notifications: '/notificationscentre/notifications',
  userNotifications: '/notificationscentre/user-notifications',
  userNotificationsWhatsNew: '/notificationscentre/user-notifications/whats-new',
  newsCentreNotificationsSettings: '/news-centre#notifications-settings',
  notificationsSettings: '/notificationscentre/notifications-settings',
  notificationsUserSettings: '/notificationscentre/notifications-settings/user-settings',
  notificationsWidget: '/notificationscentre/notifications-widget',
};
